// config
export const MAX_EVENTS_TO_LOG = 50;

// actions
export const TRIGGER_ENSIGHTEN_EVENT = 'TRIGGER_ENSIGHTEN_EVENT';

// events
export const ENSIGHTEN_APP_APPROVED = 'ApplicationApproved';
export const ENSIGHTEN_APP_DECLINED = 'ApplicationDeclined';
export const ENSIGHTEN_APP_SOFT_DECLINED = 'ApplicationSoftDeclined';
export const ENSIGHTEN_APP_START = 'ApplicationStart';
export const ENSIGHTEN_SIGNUP_FINISH = 'PersonalAccountSignupFinish';
export const ENSIGHTEN_SIGNUP_START = 'PersonalAccountSignupStart';
